import type { ReviewPage } from './review-page';

export const zillowPages: ReviewPage[] = [
  {
    label: 'Real Estate',
    breadcrumb: 'Real Estate Reviews',
    children: [
      { label: 'California', href: 'https://www.zillow.com/profile/Marshall-Reddick/' },
      { label: 'Florida', href: 'https://www.zillow.com/profile/Marshall-Reddick-FL/' },
      { label: 'Tennessee', href: 'https://www.zillow.com/profile/Marshall-Reddick-TN/' },
      {
        label: 'Texas',
        children: [
          { label: 'Houston, TX', href: 'https://www.zillow.com/profile/MR-Houston' },
          { label: 'Dallas, TX', href: 'https://www.zillow.com/profile/MR%20Dallas' },
          {
            label: 'New Braunfels / Austin, TX',
            href: 'https://www.zillow.com/profile/mr-new-braun-aus/',
          },
          {
            label: 'San Antonio, TX',
            href: 'https://www.zillow.com/profile/Marshall-Reddick-TX/',
          },
        ],
      },
    ],
  },
  {
    label: 'Property Management',
    breadcrumb: 'Property Management Reviews',
    children: [
      {
        label: 'California',
        children: [
          { label: 'Los Angeles, CA', href: 'https://www.zillow.com/profile/Marshall-Reddick-LA/' },
          {
            label: 'Orange County, CA',
            href: 'https://www.zillow.com/profile/Marshall-Reddick-PM/',
          },
        ],
      },
      {
        label: 'Florida',
        children: [
          {
            label: 'Fort Myers, FL',
            href: 'https://www.zillow.com/profile/Marshall-ReddickFL/',
          },
        ],
      },
      {
        label: 'Tennessee',
        children: [
          { label: 'Clarksville, TN', href: 'https://www.zillow.com/profile/Marshall-Reddick-CL/' },
          { label: 'Nashville, TN', href: 'https://www.zillow.com/profile/mr-nash-pm/' },
        ],
      },
      {
        label: 'Texas',
        children: [
          { label: 'Austin, TX', href: 'https://www.zillow.com/profile/Marshall-Reddick-AU/' },
          {
            label: 'Dallas, TX',
            href: 'https://www.zillow.com/profile/marshall%20reddick%20dallas',
          },
          {
            label: 'New Braunfels, TX',
            href: 'https://www.zillow.com/profile/Marshall%20Reddick%20NB',
          },
          {
            label: 'San Antonio, TX',
            href: 'https://www.zillow.com/profile/Marshall-Reddick-PM-SA/',
          },
        ],
      },
    ],
  },
  {
    label: 'Private Lending Reviews',
    href: 'https://www.zillow.com/lender-profile/MarshallReddick/',
  },
];
